import React from "react";

export default function TestGifting() {
    const icons = window.giftingIcons ?? [];
    return (
        <div style={{ color: "black", backgroundColor: "white", width: "100%", height: "100vh", padding: 20 }}>
            <p>gifting page</p>
            <pre>{JSON.stringify(icons, null, 2)}</pre>
        </div>
    );
}
